import React, { useMemo } from "react";
import { connect } from "react-redux";
import * as Actions from "actions";
import { ResizableBox } from "react-resizable";
import "./pageMargins.scss";
import { DEFAULT_PAGE_MARGINS } from "constants/TemplateEditor";

const PageMargins = (props) => {
  const { index, template, updateTemplate } = props;

  const templateContent = template.data?.templateContent ?? {};
  const { margin, isMarginApplied } = templateContent ?? {};
  const {
    top = DEFAULT_PAGE_MARGINS.top,
    left = DEFAULT_PAGE_MARGINS.left,
    bottom = DEFAULT_PAGE_MARGINS.bottom,
    right = DEFAULT_PAGE_MARGINS.right,
  } = margin ?? {};

  useMemo(() => {
    const pageElements = document.querySelectorAll(
      `div[id="divUSCPageContent"]`
    );
    if (pageElements) {
      pageElements.forEach((pageElement) => {
        if (margin && isMarginApplied && pageElement) {
          const pageSize = document
            .querySelector(".editor-page")
            .getBoundingClientRect();
          pageElement.style.width = `${pageSize.width - (left + right)}px`;
          pageElement.style.height = `${pageSize.height - (top + bottom)}px`;
        }
      });
    }
  }, [template]);

  const onResizeDone = (marginPosition, size) => {
    let newMargins;
    if (marginPosition == "topBottom") {
      newMargins = { ...templateContent?.margin, top: size, bottom: size };
    } else {
      newMargins = { ...templateContent?.margin, left: size, right: size };
    }

    const updatedTemplate = {
      ...template.data,
      templateContent: {
        ...templateContent,
        margin: newMargins,
      },
    };
    updateTemplate && updateTemplate(updatedTemplate);
  };

  return isMarginApplied ? (
    <>
      <ResizableBox
        id={`margin-top-page-${index}`}
        width={Infinity}
        height={top}
        className="page-margins top"
        resizeHandles={["s"]}
        maxConstraints={[Infinity, 200]}
        axis="y"
        onResizeStop={(e, marginData) => {
          onResizeDone("topBottom", marginData.size.height);
        }}
      />
      <ResizableBox
        id={`margin-left-page-${index}`}
        width={left}
        height={Infinity}
        resizeHandles={["e"]}
        maxConstraints={[200, Infinity]}
        className="page-margins left"
        axis="x"
        onResizeStop={(e, marginData) => {
          onResizeDone("leftRight", marginData.size.width);
        }}
      />
      <ResizableBox
        id={`margin-right-page-${index}`}
        width={right}
        height={Infinity}
        className="page-margins right"
        resizeHandles={["w"]}
        maxConstraints={[200, Infinity]}
        axis="x"
        onResizeStop={(e, marginData) => {
          onResizeDone("leftRight", marginData.size.width);
        }}
      />
      <ResizableBox
        id={`margin-bottom-page-${index}`}
        width={Infinity}
        height={bottom}
        className="page-margins bottom"
        resizeHandles={["n"]}
        maxConstraints={[Infinity, 200]}
        axis="y"
        onResizeStop={(e, marginData) => {
          onResizeDone("topBottom", marginData.size.height);
        }}
      />
    </>
  ) : (
    <></>
  );
};

const mapStateToProps = (state) => {
  const { templatesHistory } = state;
  const { template } = templatesHistory;

  return {
    template,
  };
};

const { template } = Actions.templatesHistory;

const mapDispatchToProps = {
  updateTemplate: template.update,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(PageMargins);
